import { FileText, Calendar, Loader } from 'lucide-react';
import { useLegalContent } from '../../utils/legalContent';

export const TermsModal = () => {
  const { content, loading, error } = useLegalContent();

  if (loading) {
    return (
      <div className="p-6 flex items-center justify-center">
        <Loader className="w-8 h-8 text-brand animate-spin" />
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="p-6 text-center">
        <p className="text-status-error">Failed to load terms of service content.</p>
        <p className="text-th-secondary text-sm mt-2">
          Please check your legal-content.json file.
        </p>
      </div>
    );
  }

  const terms = content.termsOfService;

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="card p-6">
        <div className="flex items-center space-x-3 mb-4">
          <FileText className="w-6 h-6 text-brand" />
          <h3 className="text-xl font-semibold text-th-primary">
            {terms.title}
          </h3>
        </div>
        <div className="flex items-center space-x-2 text-th-secondary text-sm">
          <Calendar className="w-4 h-4" />
          <span>Last updated: {content.lastUpdated}</span>
        </div>
      </div>

      {/* Terms Content */}
      <div className="card p-6 space-y-6">
        {terms.sections.map((section, index) => (
          <div key={index}>
            <h4 className="text-lg font-semibold text-th-primary mb-3">
              {section.title}
            </h4>
            <p className="text-th-secondary leading-relaxed mb-3">
              {section.content}
            </p>
            {section.list && (
              <ul className="list-disc list-inside text-th-secondary space-y-1 ml-4">
                {section.list.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      {/* Contact Information */}
      <div className="bg-elevated border border-subtle rounded-xl p-6">
        <h4 className="text-lg font-semibold text-th-primary mb-3">
          {terms.contact.title}
        </h4>
        <p className="text-th-secondary mb-3">
          {terms.contact.content}
        </p>
        <div className="text-th-primary">
          <p>Email: {terms.contact.email}</p>
          {terms.contact.website && (
            <p>Website: {terms.contact.website}</p>
          )}
        </div>
      </div>
    </div>
  );
};
